import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AppEntry() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center paper-grain"><Loader2 className="w-8 h-8 animate-spin text-[#0F4C81]" /></div>;
  if (!user) return <Navigate to="/accedi?next=%2Fapp" replace />;
  if (user.role === "admin") return <Navigate to="/mobile" replace />;
  if (user.role === "agent") return <Navigate to="/agente-mobile" replace />;
  return <Navigate to={user.role === "b2b" ? "/listino" : "/account"} replace />;
}
